function handleError(error) {
  const err = {
    message: null,
    code: null,
    error_data: null,
    type: null,
  }

  if (error.response) {
    err.message = error.response.data.message
    err.code = error.response.data.code
    err.error_data = error.response.data.error_data
    err.type = error.response.data.type
  } else if (error.request) {
    err.message = 'No response from server'
    err.code = error.status
    err.type = 'NO_CONNECTION'
    err.error_data = null
  } else {
    err.message = 'Undefined error'
    err.code = 500
    err.type = 'UNDEFINED_ERROR'
    err.error_data = null
  }

  return err
}

export default handleError
